import { usePermissionsContext } from "../context/permissions-context";
import type { Permissions } from "../types";

/**
 * Hook to get the current user's permissions.
 * Permissions are computed at app startup and provided via context.
 */
export function usePermissions(): Permissions {
  const { permissions } = usePermissionsContext();
  return permissions;
}
